import Component from './PreviousPage.vue';

export default {
  install(Vue) {
    Vue.component('BkfActionPreviousPage', Component);
  },
};
